import React, { useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { FaX } from "react-icons/fa6";
import { NavLink, Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Header = () => {
  const [openTab, setOpenTab] = useState(false);
  const [mobileDropdown, setMobileDropdown] = useState(false);

  return (
    <nav className="w-full z-50 bg-white md:bg-white md:shadow-md transition-all">
      <div className="container mx-auto px-4 sm:px-2 lg:px-8">
        <div className="flex items-center justify-between md:justify-evenly gap-10 h-20">

          <NavLink to="/" end className="z-50 w-[20%]">
            <LazyLoadImage
              src="/TECH X AFRICA 1.png"
              alt="Logo"
              className="w-28 object-contain"
            />
          </NavLink>

          {/* Desktop Nav */}
          <div className="hidden md:flex w-[80%] justify-center items-center gap-8 text-black">
            {[
              { to: "/#about", label: "About" },
              { to: "/who-attended", label: "Who Attended" },
              // { to: "/speakers", label: "Speakers" },
              { to: "/#about", label: "On News" },
              { to: "/past-partners", label: "Past Partners & Sponsors" },
            ].map(({ to, label }) => (
              <NavLink
                key={to}
                to={to}
                className="hover:text-red-500 transition duration-300"
              >
                {label}
              </NavLink>
            ))}
          </div>

          {/* Mobile Menu Toggle */}
          <div className="flex items-center gap-4 md:hidden">
            {!openTab ? (
              <GiHamburgerMenu
                size={25}
                className="cursor-pointer text-black"
                onClick={() => setOpenTab(true)}
              />
            ) : (
              <FaX
                size={25}
                className="cursor-pointer text-black"
                onClick={() => setOpenTab(false)}
              />
            )}
          </div>
        </div>

        {/* Mobile Menu */}
        <div
          className={`md:hidden overflow-hidden transition-[max-height] duration-500 ease-in-out ${
            openTab ? "max-h-[500px]" : "max-h-0"
          }`}
        >
          <div className="flex flex-col gap-2 py-4 text-black bg-white shadow-md">
            <NavLink
              to="/#about"
              onClick={() => setOpenTab(false)}
              className="px-4 py-2 rounded-lg hover:bg-[#F63A0A] hover:text-white transition-all duration-300"
            >
              About
            </NavLink>
            <NavLink
              to="/who-is-coming"
              onClick={() => setOpenTab(false)}
              className="px-4 py-2 rounded-lg hover:bg-[#F63A0A] hover:text-white transition-all duration-300"
            >
              Who is Coming
            </NavLink>
            {/* <Link
              to="/speakers"
              onClick={() => setOpenTab(false)}
              className="px-4 py-2 rounded-lg hover:bg-[#F63A0A] hover:text-white transition-all duration-300"
            >
              Speakers
            </Link> */}

            {/* Mobile Dropdown */}
            <div className="px-4 py-2">
              <button
                onClick={() => setMobileDropdown(!mobileDropdown)}
                className="font-semibold w-full text-left"
              >
                Get Involved
              </button>
              {mobileDropdown && (
                <div className="mt-2 flex flex-col gap-2">
                  <a
                    href="https://bit.ly/txavolunteer2025"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-4 py-2 rounded-lg hover:bg-[#F63A0A] hover:text-white transition-all duration-300"
                  >
                    Apply to Volunteer
                  </a>
                  <a
                    href="/TXA 25 Official Proposal.pdf"
                    download
                    className="px-4 py-2 rounded-lg hover:bg-[#F63A0A] hover:text-white transition-all duration-300"
                  >
                    Become a Sponsor
                  </a>
                  <a
                    href="https://wa.me/+2348123051357"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-4 py-2 rounded-lg hover:bg-[#F63A0A] hover:text-white transition-all duration-300"
                  >
                    Become a Partner
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;
